var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "themeArea"
  }, [!_vm.dataLoaded ? _c('div', {
    staticClass: "themeScreenLoading"
  }, [_vm._m(0)]) : _vm._e(), !_vm.hasScheduledActivity && _vm.dataLoaded ? _c('div', {
    staticClass: "themeScreen",
    style: {
      backgroundColor: _vm.theme.color
    },
    attrs: {
      "id": "themeScreen"
    }
  }, [_c('div', {
    staticClass: "themeTitle"
  }, [_vm._v(_vm._s(_vm.theme.name))]), !_vm.isSpeedyKid ? _c('div', {
    staticClass: "theme-progress-area"
  }, [_vm._m(1), _c('div', {
    staticClass: "theme-progress-container"
  }, _vm._l(_vm.progressDivisions, function (item) {
    return _c('divider', {
      key: item.key,
      attrs: {
        "bordercolor": _vm.theme.color,
        "awardname": _vm.theme.awardName,
        "progress-bg": item.progressBg,
        "progress": item.progress
      }
    });
  }), 1)]) : _c('div', {
    staticClass: "theme-progress-area"
  }, [_c('div', {
    staticClass: "speedyGoodJob"
  }, [_c('p', [_vm._v("You're doing a great job, " + _vm._s(_vm.username) + "!")])])]), _c('a', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToActivity($event);
      }
    }
  }, [_c('div', {
    staticClass: "theme-button-continue",
    domProps: {
      "innerHTML": _vm._s(_vm.button)
    }
  })])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "themeIconWrapper",
    attrs: {
      "id": "iconOutline"
    }
  }, [_c('div', {
    staticClass: "themeIcon",
    attrs: {
      "id": "themeIcon"
    }
  })]);
}]

export { render, staticRenderFns }